import dynamic from 'next/dynamic';

export default dynamic(() => import(/* webpackChunkName:"GoogleMaps" */ './GoogleMap').then((mod) => mod.default));
